'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.QueryNodeRegistryClass = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _QueryNode = require('./QueryNode');

var _QueryNode2 = _interopRequireDefault(_QueryNode);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QueryNodeRegistry = function () {
    function QueryNodeRegistry() {
        (0, _classCallCheck3.default)(this, QueryNodeRegistry);

        this._registry = {};
    }

    (0, _createClass3.default)(QueryNodeRegistry, [{
        key: 'register',
        value: function register(constructor) {
            if (typeof constructor !== 'function' || typeof constructor.name !== 'string' || constructor.name === '') {
                throw new Error('Can only register named functions.');
            }
            this._registry[constructor.name] = constructor;
        }
    }, {
        key: 'resolve',
        value: function resolve(name) {
            return this._registry[name];
        }
    }, {
        key: 'reconstituteDeserializedJson',
        value: function reconstituteDeserializedJson(deserializedObject) {
            var _this = this;

            if (deserializedObject instanceof _QueryNode2.default) {
                return deserializedObject;
            }
            var children = deserializedObject._children ? deserializedObject._children.map(function (child) {
                return _this.reconstituteDeserializedJson(child);
            }) : [];
            var typeObj = this.resolve(deserializedObject._type);
            if (!typeObj) {
                throw new Error('Could not resolve type of deserialized object.');
            }
            var data = deserializedObject._data;
            var nodeId = deserializedObject._nodeId;
            var newObject = new typeObj({ data: data, children: children, nodeId: nodeId });
            return newObject;
        }
    }, {
        key: 'hasAncestorWithName',
        value: function hasAncestorWithName(type, name) {
            if (type === name) {
                return true;
            }
            var typeObj = this.resolve(type);
            if (!typeObj) {
                throw new Error('Type ' + type + ' not registered');
            }
            var prototype = (0, _getPrototypeOf2.default)(typeObj);
            while (prototype) {
                if (prototype.name === name) {
                    return true;
                }
                prototype = (0, _getPrototypeOf2.default)(prototype);
            }
            return false;
        }
    }, {
        key: 'safeReconstitute',
        value: function safeReconstitute(value) {
            if (value && this.resolve(value._type)) {
                try {
                    return this.reconstituteDeserializedJson(value);
                } catch (e) {
                    return value;
                }
            }
            return value;
        }
    }, {
        key: 'evaluate',
        value: function evaluate(value) {
            var node = this.safeReconstitute(value);
            if (node instanceof _QueryNode2.default) {
                return node.toQueryFragment();
            }
            return node;
        }

        //deeply clones an entire queryNode structure, including the nodeIds
        //cloned valuesets are not revived as valueSets

    }, {
        key: 'clone',
        value: function clone(queryNode) {
            var _this2 = this;

            var typeObj = this.resolve(queryNode.type);
            var clonedChildren = queryNode.children.map(function (child) {
                return _this2.clone(child);
            });
            var clonedData = (0, _lodash.cloneDeep)(queryNode.data);
            return new typeObj({
                nodeId: queryNode.nodeId,
                data: clonedData,
                children: clonedChildren
            });
        }
    }, {
        key: 'getAncestorChain',
        value: function getAncestorChain(nodeType) {
            var typeObj = this.resolve(nodeType);
            if (!typeObj) {
                throw new Error('Type ' + nodeType + ' not registered');
            }
            var ancestors = [];
            var prototype = (0, _getPrototypeOf2.default)(typeObj);
            while (prototype) {
                ancestors.push(prototype.name);
                if (prototype.name === 'QueryNode') {
                    //QueryNode should be the topmost element we care about
                    break;
                }
                prototype = (0, _getPrototypeOf2.default)(prototype);
            }
            return ancestors;
        }
    }]);
    return QueryNodeRegistry;
}();

exports.default = new QueryNodeRegistry();
exports.QueryNodeRegistryClass = QueryNodeRegistry;